import { render, staticRenderFns } from "./DespachosPorAduana.vue?vue&type=template&id=4651159f"
import script from "./DespachosPorAduana.vue?vue&type=script&lang=js"
export * from "./DespachosPorAduana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports